import {
  createContext,
  type PropsWithChildren,
  Suspense,
  useCallback,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';
import { ApplicationSkeleton } from '@/components/LoadingSkeleton';

const InitialPageContext = createContext({ pending: false, complete: () => {} });

export function InitialPageLoading({ children }: PropsWithChildren) {
  const [pending, setPending] = useState(true);
  const complete = useCallback(() => setPending(false), []);
  return (
    <InitialPageContext.Provider value={{ pending, complete }}>
      <Suspense fallback={<ApplicationSkeleton />}>{children}</Suspense>
    </InitialPageContext.Provider>
  );
}

export function useInitialPagePending() {
  return useContext(InitialPageContext).pending;
}

/** A suspended route cannot commit this effect until its content or error UI is ready. */
export function PageReady({ children }: PropsWithChildren) {
  const { complete } = useContext(InitialPageContext);
  useLayoutEffect(complete, [complete]);
  return children;
}
